import React from 'react';
import { Layout, Menu } from 'antd';  // Import Menu and Layout from Ant Design
import { Link } from 'react-router-dom';
import { CiPower } from 'react-icons/ci';
import { LiaSitemapSolid } from 'react-icons/lia'; // Assuming you're using this icon
import { useLocation } from 'react-router-dom';

// Import SubMenu explicitly
const { Sider } = Layout;
const { SubMenu } = Menu; // Make sure to import SubMenu

const Sidebar = (props) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const location = useLocation();

  // Handle the logout (you'll have to define the logout logic)
  const logout = () => {
    // Your logout logic here
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{
        position: 'fixed',
        top: '64px', // Height of the fixed header
        left: 0,
        bottom: 0,
        zIndex: 1000,
        backgroundColor: '#ffff',
        paddingTop: '20px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <Menu
            style={{ marginTop: '10px' }}
            theme="light"
            mode="inline"
            defaultSelectedKeys={[location.pathname]}
            selectedKeys={[location.pathname]}  // Ensure selected key matches the active page
          >
            <Menu.ItemGroup key="general" label={<p style={{ fontWeight: 'bold', marginBottom: '0px' }}>Menu</p>} />

            {props.user && props.user.role === 'admin' && (
              <SubMenu
                key="utm-mapping"
                icon={<LiaSitemapSolid />}
                title="UTM Mapping"
              >
                <Menu.Item key="/admin/utm-mapping">
                  <Link to="/admin/utm-mapping" style={{ textDecoration: 'none' }}>
                    UTM Mapping Overview
                  </Link>
                </Menu.Item>
                <Menu.Item key="/admin/utm-mapping/create">
                  <Link to="/admin/utm-mapping/create" style={{ textDecoration: 'none' }}>
                    Create UTM Mapping
                  </Link>
                </Menu.Item>
                <Menu.Item key="/admin/utm-mapping/history">
                  <Link to="/admin/utm-mapping/history" style={{ textDecoration: 'none' }}>
                    UTM Mapping History
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}
          </Menu>
        </div>

        <button
          style={{
            margin: collapsed ? '0 10px 20px 10px' : '0 20px 20px 20px',
            padding: '10px',
            backgroundColor: '#FFF2F3',
            color: '#E72A3D',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
          onClick={logout}
        >
          <CiPower style={{ fontSize: 'large', margin: '0px 5px 2px 0px' }} /> Logout
        </button>
      </div>
    </Sider>
  );
};

export default Sidebar;
